module.exports = __webpack_public_path__ + "img/card-wait.13449d43.png";